module.exports = __webpack_public_path__ + "static/terms-decab17aef58e2e221ccf42000eadb6e.png";